<template>
  <div class="mb-5 forward-section reply-section pr-2" id="reply-section">
    <v-card>
      <div class="d-flex pt-2 justify-space-between flex-wrap">
        <div class="d-flex align-center">
          <div>
            <v-menu offset-y attach v-if="!isExpanded && (commentType == 'ticket_reply'|| commentType == 'note')">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="black--text float-left pl-2">
                  {{ commentType === 'note' ? 'Internal Note': 'reply' | upperCaseFirst }}
                  <v-icon v-if="attrs['aria-expanded'] == 'false'">mdi-menu-down</v-icon>
                  <v-icon v-if="attrs['aria-expanded'] == 'true'">mdi-menu-up</v-icon>
                </span>
              </template>
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    class="cursor-pointer"
                    v-for="(item, index) in replyList"
                    :key="index"
                    :disabled="(ticketAccess.contactRemoved || supportEmailList.length == 0) &&item.value === 'ticket_reply'"
                    @click="setReplyType(item)"
                    v-track="'set-reply'"
                    :class="{ 'v-list-item--active': item.value === commentType }"
                  >
                    <v-list-item-title> {{ item.name }} </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <v-divider v-if="!isExpanded && commentType == 'ticket_reply'" vertical class="small-divider mx-1"></v-divider>
          </div>
          <div class="d-flex align-center mt-n1" v-if="commentType !== 'note'">
            <span class="px-2 pl-2 grey--text text--darken-2 text-center">From:</span>
            <v-menu offset-y attach max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="grey--text text--darken-2 d-flex">
                  <span class="text-truncate max-width-200"> {{ fromEmailAddress }} </span>
                  <v-icon v-if="attrs['aria-expanded'] == 'false'">mdi-menu-down</v-icon>
                  <v-icon v-if="attrs['aria-expanded'] == 'true'">mdi-menu-up</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in supportEmailList"
                    :key="index"
                    @click="setSupportEmail(item)"
                    v-track="'set-support-email'"
                  >
                    <v-list-item-title class="d-flex">
                      <div v-if="item.name" class="support-email-name pr-1">{{ item.name | upperCaseFirst }}</div>
                      <span class="grey--text text--darken-2 text-truncate">{{ item.email }}</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div class="right-section d-flex mt-n1 pb-1">
          <v-tooltip top v-if="commentType !== 'note'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="pa-0" v-track="'expand-reply-section-btn-click'" icon @click.stop="showReplySection" min-width="40px">
                <v-icon size="24px">{{ isExpanded ? 'mdi-arrow-collapse' : 'mdi-arrow-top-right-bottom-left'}}</v-icon>
              </v-btn>
            </template>
            <span> {{ isExpanded ? 'Collapse Reply Box' : 'Expand Reply Box' }}</span>
          </v-tooltip>
          <FileUploader page="ckeditor" @saveAttachment="saveAttachment"></FileUploader>
          <template>
            <ReplyTemplate v-if="commentType !== 'note'" @useTemplate="updateBody" :ticketData="ticketData"></ReplyTemplate>
          </template>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="email-section grey--text text--darken-2" v-if="commentType !== 'note'">
        <v-row no-gutters class=" border-bottom" v-if="toEmail">
          <v-col cols="auto" class="pa-0 pt-2 pl-2">
            <span>To:</span>
          </v-col>
          <v-col class="pa-0">
            <SearchContact
              v-if="loadSearchComp"
              @getValue="getToEmailAddress"
              :commentType="commentType+'_to_email'"
              emailType="to_email"
              :defaultValue="toEmailAddress"
              :selectedList="commentType ==='thread_reply' ? toEmailAddress : [] "
            ></SearchContact>
          </v-col>
          <v-col align="right" cols="auto" v-if="ccBccEmail"> 
            <v-btn x-small class="py-5 text-capitalize" text @click="addCCaction()" :disabled="CCemailColumn" v-track="'add-cc-btn-action'">Cc</v-btn>
            <v-btn x-small class="py-5 text-capitalize" text  @click="addBCCaction()" :disabled="BCCEmailColumn" v-track="'add-bcc-btn-action'">Bcc</v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="border-bottom" v-if="CCemailColumn">
          <v-col cols="auto" class="pa-0 pt-2 pl-2">
            <span>Cc:</span>
          </v-col>
          <v-col class="pa-0 pr-2" align="right">
            <SearchContact
              @getValue="getCCemailAddress"
              emailType="cc"
              :commentType="commentType"
              :defaultValue="toEmailAddress"
              :selectedList="CCemailAddress"
              :existingEmails="BCCemailAddress"
              @removeColumn="removeColumn('cc-email')"
              :key="loadSearchComp"
            ></SearchContact>
          </v-col>
        </v-row>
        <v-row no-gutters class="border-bottom" v-if="BCCEmailColumn">
          <v-col cols="auto" class="pa-0 pt-2 pl-2">
            <span>Bcc:</span>
          </v-col>
          <v-col class="pa-0 pr-2" align="right">
            <SearchContact
              @getValue="getBCCemailAddress"
              emailType="bcc"
              :commentType="commentType"
              :defaultValue="toEmailAddress"
              :existingEmails="CCemailAddress"
              @removeColumn="removeColumn('bcc-email')"
              :selectedList="[]"
            ></SearchContact>
          </v-col>
        </v-row>
      </div>
      <v-card-text class="pa-0">
        <div v-if="pageName == 'reply-chain'" class="content-editor" :class="{'content-resize': !isExpanded && commentType==='ticket_reply', 'expanded-editor': isExpanded }">
          <CKEditor
            v-if="editorHTML"
            @update="getEditorHTML"
            :body="editorHTML"
            :key="loadCKeditor"
            :page="pageName"
            :threadMsgDateUser="threadMessageDateandUser"
            @onReady="getInstance"
          ></CKEditor>
          <div v-if="commentType==='ticket_reply'" :class="{'resizable': !isExpanded}" ></div>
        </div>
        <div v-if="pageName == 'blank_editor'" class="blank-editor">
          <CKEditor
            @update="getEditorHTML"
            :body="editorHTML"
            :key="loadCKeditor"
            :page="pageName"
            @onReady="getInstance"
          ></CKEditor>
        </div>
        <v-col
          cols="12"
          v-if="dropedFiles.length || attachmentFiles.length"
          id="attachment-with-reply-box"
        >
          <h6 class="text-subtitle-1">
            <span class="secondary--font black--text">
              Attachments ({{ dropedFiles.length + attachmentFiles.length }})
            </span>
          </h6>
          <template v-for="(file, index) in dropedFiles">
            <v-chip
              color="#CBDAE8"
              :key="index"
              class="ml-0 ma-2 mr-3"
              close
              @click:close="removeAttchment(file, 'new')"
            >
              {{ file.name | upperCaseFirst }}
            </v-chip>
          </template>
          <template v-for="(file, index) in attachmentFiles">
            <v-chip
              color="#CBDAE8"
              :key="index"
              class="ml-0 ma-2 mr-3"
              close
              @click:close="removeAttchment(file, 'old')"
            >
              {{ file.file_name | upperCaseFirst }}
            </v-chip>
          </template>
        </v-col>
      </v-card-text>
    </v-card>

      <v-card-actions v-if="!isExpanded" :class="{'pl-0': commentType==='ticket_reply'|| commentType==='note' }">
        <div class="mt-2">
          <v-btn outlined class="font-weight-bold" v-track="'cancel-reply-btn-action'" @click="cancelReply()">Cancel</v-btn>
          <v-btn v-if="commentType === 'forward' || commentType === 'forward_ticket' || commentType === 'thread_reply'" :disabled="!toEmailAddress.length > 0" color="black" class="font-weight-bold ml-4" v-track="'send-forward-button'" @click="sendReplyForward()"><span class="white--text">Send</span></v-btn>
          <v-btn-toggle v-else dense class="ml-2" :dark="!disableSendButton" :class="disableSendButton ? 'disable-events' : ''">
            <v-btn v-if="commentType == 'note'" class="font-weight-bold" v-track="'send-note-btn-action'" @click="sendNote()"><span class="white--text">{{ commentType === "note" ? "Save" : "Send" }}</span></v-btn>
            <v-btn v-else class="font-weight-bold" v-track="'send-reply-btn-action'" @click="sendReplyForward()"><span class="white--text">{{ commentType === "note" ? "Save" : "Send" }}</span></v-btn>
            <v-menu offset-y attach left top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn min-width="30px" :disabled="editorHTML ? false : true">
                  <span v-bind="attrs" v-on="on" class="black--text float-left">
                    <v-icon v-if="attrs['aria-expanded'] == 'false'">mdi-menu-down</v-icon>
                    <v-icon v-if="attrs['aria-expanded'] == 'true'">mdi-menu-up</v-icon>
                  </span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group v-if="commentType == 'note'">
                  <v-list-item class="cursor-pointer" v-track="'send-note-with-status'" v-for="(item, index) in filteredSendStatusListForNote" :key="index" @click="sendNote('status', item)">
                    <v-list-item-title> {{ item.name }} </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
                <v-list-item-group v-else>
                  <v-list-item class="cursor-pointer" v-track="'send-reply-with-status'" v-for="(item, index) in filteredSendStatusList" :key="index" @click="sendReplyForward('status', item)">
                    <v-list-item-title> {{ item.name }} </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-btn-toggle>
        </div>
      </v-card-actions>
    <v-dialog v-model="cancelDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize">Cancel<span> Draft</span></span>
        </v-card-title>
        <v-card-text class="body-2">
          <p>Are you sure you want to cancel the draft message ?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDialog = false" class="font-weight-bold" v-track="'continue-to-send-note'">Continue</v-btn>
          <v-btn dark @click="confirmCancel()" class="font-weight-bold" v-track="'cancel-sending-note'">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <ReplyDialog
        ref="replyDialog"
        :ticketData="ticketData"
        :commentType="commentType"
        :supportEmailList="supportEmailList"
        :editorHTML="editorHTML"
        :disableSendButton="disableSendButton"
        @cancel-reply="cancelReply"
        @send-reply="sendReplyForward"
        :lastCommentData="lastCommentData"
        :filteredSendStatusList="filteredSendStatusList"
      ></ReplyDialog>
    </div>
  </div>
</template>

<script>
import CKEditor from "@/components/ckeditor/Editor";
import FileUploader from "@/components/file_uploader/UploadFile";
import SearchContact from "@/components/tickets/reply/SearchContact";
import ReplyTemplate from "@/components/tickets/reply/TemplateDrawer";
import { attachmentfileactionMixin } from "@/mixins/attachmentFileAction.js";
import ReplyDialog from "@/components/tickets/reply/ReplyDialog";
import { mapGetters, mapMutations } from "vuex";
import { $tickets } from "@/services/Index";

export default {
  props: {
    ticketAccess: {
      type: Object,
      default: ()=> ({})
    },
    ticketData: {
      type: [Object, Array],
      required: true
    },
    ticketAccess: [Object],
    supportEmailList:{
      type: [Object, Array],
      default: ()=> ([])
    },
    selectedCommentId:{
      type: [Number ,String],
      default: 0
    },
    commentType:{
      type: [String],
      default: 'ticket_reply'
    },
    toEmail:{
        default: true,
        type: Boolean
    },
    ccBccEmail:{
        default: true,
        type: Boolean
    },
    selectedAction: {
      type: [Number, String],
      default:"forward"
    },
    lastCommentData:{
      type: [Object, Array],
      required: false,
    } 
  },
  mixins: [attachmentfileactionMixin],
  components: {
    CKEditor,
    FileUploader,
    SearchContact,
    ReplyTemplate,
    ReplyDialog
  },
  data() {
    return {
      currentTicket: this.ticketData,
      fromEmailAddress: "",
      supportEmailName: "",
      toEmailAddress: [],
      disableSendButton: false,
      loadSearchComp:false,
      commentName: "Reply",
      CCemailAddress: [],
      BCCemailAddress: [],
      CCemailColumn: false,
      BCCEmailColumn: false,
      attachmentFiles: [],
      dropedFiles: [],
      editorHTML: "",
      loadCKeditor: false,
      cancelDialog: false,
      existingAttachmentIds: [],
      incoming: false,
      private: false,
      editorInstance: null,
      lastCommentHtml: "",
      threadMessageDateandUser: null,
      pageName: "reply-chain",
      existinAttachments:[],
      sendStatusList: [
        {
          name: "Send and set as Open",
          status: "open",
        },
        {
          name: "Send and set as Pending",
          status: "pending",
        },
        {
          name: "Send and set as On hold",
          status: "on_hold",
        },
        {
          name: "Send and set as Closed",
          status: "closed",
        },
      ],
      sendStatusListForNote: [
        {
          name: "Save note and set as Open",
          status: "open",
        },
        {
          name: "Save note and set as Pending",
          status: "pending",
        },
        {
          name: "Save note and set as On hold",
          status: "on_hold",
        },
        {
          name: "Save note and set as Closed",
          status: "closed",
        },
      ],
      replyList: [
        { name: "Reply", value: "ticket_reply" },
        { name: "Internal Note", value: "note" },
      ],
    };
  },

  computed: {
    commentList() {
      return this.$store.getters["tickets/listOfComments"];
     },
    ...mapGetters({
      replyData: 'reply/replyData',
      isExpanded: 'reply/replyExpanded'
    }),

    filteredSendStatusListForNote() {
      let filteredList = this.sendStatusListForNote.filter((statusList) => {
        return statusList.status !== this.ticketData.status;
      });
      return filteredList;
    },

    filteredSendStatusList() {
      let filteredList = this.sendStatusList.filter((statusList) => {
        return statusList.status !== this.ticketData.status;
      });
      return filteredList;
    },
  },

  mounted() {
    if (this.ticketData) {
        this.fromEmailAddress = this.ticketData.to_emails[0] || (this.supportEmailList.length ? this.supportEmailList[0].email : '');
    }

    if (this.commentType === 'ticket_reply') {
        this.toEmailAddress.push(this.ticketData.contact_email);
        this.checkCCAddressData();
    }

    if (this.lastCommentData) {
        this.toEmailAddress = this.lastCommentData.to_emails;
        this.commentThreadId = this.lastCommentData.comments_thread_id;
        this.CCemailAddress = this.lastCommentData.cc_emails || [];
        this.CCemailColumn = !!this.CCemailAddress.length;
    } else {
        this.CCemailColumn = false;
    }

    this.loadSearchComp = true;
    this.setEditorBlank();
  },

  
  methods: {
    ...mapMutations({
      setToEmailAddress: "reply/setToEmailAddress",
      setReplyExpanded: "reply/setReplyExpanded",
      setCCemailAddress: "reply/setCCemailAddress",
      setBCCemailAddress: "reply/setBCCemailAddress",
      setExistingAttachmentIds: "reply/setExistingAttachmentIds",
      setBlankReplyData: "reply/setBlankReplyData"
    }),

    setReplyType(item) {
      this.$emit('reload_editor', item.value )
    },

    getToEmailAddress(toEmail) {
        this.toEmailAddress = toEmail;
        this.setToEmailAddress(this.toEmailAddress)
    },

     addCCaction() {
      this.CCemailColumn = true;
    },

    addBCCaction() {
      this.BCCEmailColumn = true;
    },

    setReplyChainInCkeditor() {
        let lastMessage = "";
        let lastCommentIndex = null;
        if(this.commentType === 'thread_reply'){
            lastCommentIndex = this.lastCommentData;
            lastMessage = this.lastCommentData.body
        }
        else {
            if (this.commentList.length && this.selectedAction !== 'forward_ticket') {
                this.commentList.forEach((item) => {
                if ((!this.selectedCommentId || item.id == this.selectedCommentId) && item.action.type === "comment" && item.action.content.comment_type == "reply") {
                    lastCommentIndex = item.action.content;
                }
                });
            }
            if (lastCommentIndex && lastCommentIndex.comment_type == "reply") {
                lastMessage = lastCommentIndex.body;
            }
            else {
                this.pageName = "reply-chain";
                lastMessage = this.ticketData.description;
            }
        }
        this.threadMessageDateandUser = this.returnMessageDateAndUser(lastCommentIndex);
        this.lastCommentHtml = lastMessage;
        this.editorHTML = this.lastCommentHtml;
        this.loadCKeditor = !this.loadCKeditor;
        if (this.commentType === 'forward' || this.commentType === 'forward_ticket' ) {
            this.checkexistingAttachments(lastCommentIndex ? lastCommentIndex : this.ticketData)
        }
    },

    checkexistingAttachments(comment) {
      if (comment.attachment_info.length) {
        this.attachmentFiles = comment.attachment_info
        this.existingAttachmentIds = comment.attachment_info.map(item => item.attachment_id);
      }
    },
    returnMessageDateAndUser(messageIndex) {
      let date = "";
      let user = "";
      if (this.commentList.length && messageIndex) {
        date = this.$options.filters.formatDate(messageIndex.created_at, "lll");
        user = messageIndex.user.email;
      } else {
        date = this.$options.filters.formatDate(this.ticketData.created_at, "lll");
        user = this.ticketData.contact_email || "";
      }
      return `On ${date} <i>${user}</i> wrote:`;
    },

    setEditorBlank() {
      if (this.commentType === "note") {
        this.pageName = "blank_editor";
        this.editorHTML = "";
        this.loadCKeditor = !this.loadCKeditor;
      } else {
        this.pageName = "reply-chain";
        this.setReplyChainInCkeditor();
      }
    },

    /** adding default selected Cc emails from last comment or ticket details data */

   checkCCAddressData() {
    const replyComment = this.commentList
        .slice()
        .reverse()
        .find(comment => comment.action.type === "comment" && comment.action.content.comment_type === "reply");

    if (replyComment) {
        const lastCommentIndex = replyComment.action.content;

        // Code to add last from email in CC if it is different from the service cloud support email.
        if (
            lastCommentIndex.from_email !== this.fromEmailAddress &&
            !this.toEmailAddress.includes(lastCommentIndex.from_email)
        ) {
            this.CCemailAddress.push(lastCommentIndex.from_email);
            this.CCemailColumn = true;
        } else if (
            lastCommentIndex.cc_emails &&
            lastCommentIndex.cc_emails.length
        ) {
            lastCommentIndex.cc_emails.forEach(email => {
                if (!this.toEmailAddress.includes(email)) {
                    if (email === this.fromEmailAddress) {
                        this.CCemailAddress.push(lastCommentIndex.from_email);
                    } else {
                        this.CCemailAddress.push(email);
                    }
                    this.CCemailColumn = true;
                }
            });
        }
    } else {
        this.addCCEmailsFromTicketData();
    }
},

    addCCEmailsFromTicketData() {
      if (this.ticketData.cc_emails && this.ticketData.cc_emails.length) {
        this.ticketData.cc_emails.forEach((email) => {
          if (!this.toEmailAddress.includes(email)) {
            this.CCemailAddress.push(email);
            this.CCemailColumn = true;
          }
        });
      }
    },

    setSupportEmail(item) {
      this.fromEmailAddress = item.email;
      if (this.CCemailAddress.length) {
        this.CCemailAddress.forEach((email, index) => {
          if (email == this.fromEmailAddress) {
            this.CCemailAddress.splice(index, 1);
          }
        });
      }
      this.supportEmailName = item.name ? item.name : "";
    },

    removeColumn(column) {
      if (column == "cc-email") {
        this.CCemailColumn = false;
        this.CCemailAddress = [];
      } else {
        this.BCCEmailColumn = false;
        this.BCCemailAddress = [];
      }
    },
    
    getEditorHTML(htmlData) {
      this.editorHTML = htmlData;
      this.$store.commit('reply/setEditorData', htmlData)
      if (htmlData == "") {
        this.pageName = "blank_editor";
      }
    },

    cancelReply() {
      if (this.editorHTML) {
        this.cancelDialog = true;
      } else {
        this.$emit("oncancel");
        this.setReplyExpanded(false)
      }
    },

    confirmCancel() {
      this.$emit("oncancel");
      this.setReplyExpanded(false)
    },

    /** get CKeditor instance */
    getInstance(editor) {
      this.editorInstance = editor;
    },

    updateBody(data) {
      if (data) {
        if (this.editorInstance) {
          const viewFragment = this.editorInstance.data.processor.toView(data.body);
          const modelFragment = this.editorInstance.data.toModel(viewFragment);
          this.editorInstance.model.insertContent(modelFragment,
            this.editorInstance.model.document.selection
          );
        }
        this.attachmentFiles = [...this.attachmentFiles, ...data.attachment_info];
        if (data.attachment_info.length) {
          data.attachment_info.forEach((item) => {
            this.existingAttachmentIds.push(item.attachment_id);
          });
          this.setExistingAttachmentIds(this.existingAttachmentIds)
        }
      }
    },

    getCCemailAddress(ccEmail){
      if (ccEmail.length) {
        this.CCemailAddress = ccEmail;
        this.setCCemailAddress(this.CCemailAddress);

      }
    },
    getBCCemailAddress(bccEmail){
      if (bccEmail.length) {
        this.BCCemailAddress = bccEmail;
        this.setBCCemailAddress(this.BCCemailAddress)
      }
    },

    /** this method is used for both sending reply and sending forward as well */
    async sendReplyForward(action = "", item = "", type = "") {
      if (type === 'expanded') {
        this.editorHTML = this.replyData.editorData;
        if (this.commentType === 'forward') {
          this.toEmailAddress = this.replyData.toEmailAddress;
        }
        this.CCemailAddress = this.replyData.CCemailAddress;
        this.BCCemailAddress = this.replyData.BCCemailAddress;
        this.dropedFiles = this.replyData.dropedFiles;
        this.existingAttachmentIds = this.replyData.existingAttachmentIds;
      }
      this.editorHTML = this.sanitizeEditorHTML(this.editorHTML).replace(/<br\s*\/?>/gi, '');
      if (this.editorHTML !== "") {
        let payload = {
          comment: {
            from_email: this.fromEmailAddress,
            cc_emails: this.CCemailAddress,
            to_emails: this.toEmailAddress,
            bcc_emails: this.BCCemailAddress,
            ticket_id: this.currentTicket.id,
            comment_type: this.commentType.startsWith('forward') ? 'forward' : 'reply',
            comment_id: this.selectedCommentId,
            comments_thread_id: this.commentThreadId ? this.commentThreadId : "",
            body: this.editorHTML,
            attachment_ids: this.existingAttachmentIds,
            incoming: this.incoming,
            private: this.private,
            ticket_status: action === "status" ? item.status : '',
          },
        };
        let config = {};
        const formdata = new FormData();
        if (this.dropedFiles.length) {
          config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          for (var key in payload.comment) {
            if (key !== "cc_emails" && key !== "to_emails" && key !== "bcc_emails" && key !== "attachment_ids") {
              formdata.append(key, payload.comment[key]);
            }
          }
          formdata.append("cc_emails[]", this.CCemailAddress);
          formdata.append("to_emails[]", this.toEmailAddress);
          formdata.append("bcc_emails[]", this.BCCemailAddress);
          if (this.existingAttachmentIds.length) {
            this.existingAttachmentIds.forEach((fileId) => {
              formdata.append("attachment_ids[]", fileId);
            });
          }
          this.dropedFiles.forEach((file) => {
            formdata.append("attachments[]", file);
          });
          payload = formdata;
        }
        try {
          this.disableSendButton = true;
          const response = this.commentType.startsWith('forward') ?
            await $tickets.forwardMsg(this.currentTicket.id, payload, config, this.selectedCommentId):
            await $tickets.addReply(this.currentTicket.id, payload, config);
          if (response.data) {
            this.confirmCancel();
            this.$emit("onReply");
            this.disableSendButton = false;
            this.setReplyExpanded(false);
            if (this.commentType.startsWith('forward')) {
              this.$emit("showThreadSection",'threads')
              this.$store.dispatch("ui/snackbar", [
                {
                  title: "",
                  message: `Ticket forwarded successfully.`,
                  type: "success",
                },
              ]);
            };
           this.setBlankReplyData("")
          }
        } catch (error) {
            this.$store.dispatch("ui/snackbar", [
              {
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
            this.disableSendButton = false;
          }
        }
    },
    
     /* Method to save note in the selected ticket */
    async sendNote(action = "", item = "") {
      if (this.editorHTML !== "") {
        let payload = null;
        let data = {
          comment: {
            ticket_id: this.currentTicket.id,
            comment_type: this.commentType,
            body: this.editorHTML,
            ticket_status: "",
            attachment_ids: this.existingAttachmentIds,
          },
        };
        if (action == "status") {
          data.comment.ticket_status = item.status;
        }

        payload = data;
        let config = {};
        const formdata = new FormData();
        if (this.dropedFiles.length) {
          config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };

          let replyData = data.comment;

          for (var key in replyData) {
            formdata.append(key, replyData[key]);
          }
          this.dropedFiles.forEach((file) => {
            formdata.append("attachments[]", file);
          });
          payload = formdata;
        }
        //this.editorHTML = false;
        try {
          const response = await $tickets.addNote(
            this.currentTicket.id,
            payload,
            config
          );
          if (response.data) {
            this.confirmCancel();
            this.$emit("onReply");
          }
        } catch (error) {
          // Log any errors from the try block or API
          console.error('An error occurred:', error);
        }
      }
      //}
    },

    showReplySection() {
      if(!this.isExpanded) {
        this.$refs.replyDialog.expanded = true;
        this.setReplyExpanded(true)
      } else {
        this.$refs.replyDialog.expanded = false;
        this.setReplyExpanded(false)
      }
    },

    sanitizeEditorHTML(editorData) {
      // Create a temporary container to parse the HTML string
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = editorData;

      const replyChainContainer = tempContainer.querySelector('#reply-chain-thread');
      if (replyChainContainer) {
          const blockquote = replyChainContainer.querySelector('blockquote');
          if (blockquote) {
              // Insert the blockquote before the reply-chain-container
              replyChainContainer.parentNode.insertBefore(blockquote, replyChainContainer);
          }
          // Remove the reply-chain-container
          replyChainContainer.remove();
      }
      return tempContainer.innerHTML;
    }

  },
};
</script>

<style lang="scss">
@import "@/assets/styles/ticket-reply.scss";
</style>